import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserView, MobileView, TabletView, isBrowser, isMobile, isTablet } from 'react-device-detect';
import './styles.scss';
import Splash from './components/Splash';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Splash />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
